import { render } from "./CrawlChangeHost.vue?vue&type=template&id=65fa4ef4&scoped=true"
import script from "./CrawlChangeHost.vue?vue&type=script&lang=js"
export * from "./CrawlChangeHost.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-65fa4ef4"

export default script